import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RegisterComponent } from './pages/register/register.component';
import { SocialComponent } from './pages/social/social.component';

const routes: Routes = [
    { path: 'default', component: RegisterComponent },
    //{ path: 'social', component: SocialComponent }, E.C.S: Se desactiva esta funcionalidad momentaneamente
    {
        path: '**',
        loadChildren: () =>
            import('../not-found/not-found.module').then(
                (m) => m.NotFoundModule
            ),
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class RegisterRoutingModule {}
